import {TaskType} from '../../constants/dataEnum';

export const getConfigState = (state) => state.configState;

export const getProtocolConfig = (state) => state.configState.protocolConfig;

export const getDeepWellThreshold = (state) => state.configState.deepWellThreshold;

export const getMaxAspirateVolume = (state) => state.configState.maxAspirateVolume;

export const getMinAspirateVolume = (state) => state.configState.minAspirateVolume;

export const getRecommendedAspirateVolume = (state) => state.configState.recommendedAspirateVolume;

export const getMaxAspirateHighVolume = (state) => state.configState.maxAspirateHighVolume;

export const getMinAspirateHighVolume = (state) => state.configState.minAspirateHighVolume;

export const getRecommendedAspirateHighVolume = (state) => state.configState.recommendedAspirateHighVolume;

export const getRangeAspirateSpeed = (state) => state.configState.rangeAspirateSpeed;

export const getRangeRetractAspirateSpeed = (state) => state.configState.rangeRetractAfterAspirateSpeed;

export const getRangeMixingBeforeAspirateSpeed = (state) => state.configState.rangeMixingBeforeAspirateSpeed;

export const getRangeRetractSpeed = (state) => {
  const {rangeRetractAfterAspirateSpeed, rangeRetractAfterDispenseSpeed} = state.configState;

  return {[TaskType.ASPIRATE]: rangeRetractAfterAspirateSpeed, [TaskType.DISPENSE]: rangeRetractAfterDispenseSpeed};
};

export const getDefaultTipPosition = (state) => state.configState.defaultTipPosition;

export const getMaximumTouchOffTolerance = (state) => state.configState.maximumTouchOffTolerance;
